import type { ReactNode } from 'react';

interface FieldLabelProps {
  htmlFor: string;
  icon?: string;
  required?: boolean;
  children: ReactNode;
}

/**
 * A field's label, with the asterisk when the field has to be filled in - one component rather than the same
 * three lines in every form.
 *
 * The asterisk is drawn by the stylesheet from this class and is deliberately not in the markup: what a screen
 * reader needs is aria-required on the control, and a star in the label as well would have it read the field's
 * name as "Title star".
 */
export function FieldLabel({ htmlFor, icon, required = false, children }: FieldLabelProps) {
  return (
    <label htmlFor={htmlFor} className={required ? 'is-required' : undefined}>
      {icon && <i className={`pi ${icon} me-1`} aria-hidden="true" />}
      {children}
    </label>
  );
}
